import { PartStatus } from "../models/Part";

/**
 * Whether a part has left site - shipped by courier or collected by the customer.
 *
 * Shipped is not a stored PartStatus; it is derived from ShippedOn, the same rule the ELV part
 * report applies. Only Dismantled and Sold are overridden: a work order can ship a part that was
 * never sold, but a part sent back to QC or returned must still read as that, not Shipped.
 */
export const isPartShipped = (
  partStatus: PartStatus | null | undefined,
  shippedOn: string | null | undefined
): boolean =>
  !!shippedOn && (partStatus === PartStatus.Dismantled || partStatus === PartStatus.Sold);

/** The status label to show for a part, as an untranslated key. */
export const getPartDisplayStatusLabel = (
  partStatus: PartStatus | null | undefined,
  shippedOn: string | null | undefined
): string => {
  if (isPartShipped(partStatus, shippedOn)) return "Shipped";
  if (partStatus === null || partStatus === undefined) return "Unknown";
  return PartStatus[partStatus] ?? "Unknown";
};
